const Header = (props: React.ComponentProps<"header">) => {
  return (
    <header className="relative flex gap-[.625rem] items-center justify-center w-full py-10">
      { props.children }
    </header>
  );
};

export default Header;
